import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / system" info, drawn on a 12px grid.
export const Info = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-small", className)}
  >
    <path
      d="M6 9.65625C8.01929 9.65625 9.65625 8.01929 9.65625 6C9.65625 3.98071 8.01929 2.34375 6 2.34375C3.98071 2.34375 2.34375 3.98071 2.34375 6C2.34375 8.01929 3.98071 9.65625 6 9.65625ZM6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <path
      d="M5.775 8.25V5.03062H6.50223V8.25H5.775ZM6.14062 4.57371C6.02545 4.57371 5.92634 4.53388 5.8433 4.45424C5.76027 4.37319 5.71875 4.27608 5.71875 4.1629C5.71875 4.04832 5.76027 3.95121 5.8433 3.87156C5.92634 3.79052 6.02545 3.75 6.14062 3.75C6.25714 3.75 6.35625 3.79052 6.43795 3.87156C6.52098 3.95121 6.5625 4.04832 6.5625 4.1629C6.5625 4.27608 6.52098 4.37319 6.43795 4.45424C6.35625 4.53388 6.25714 4.57371 6.14062 4.57371Z"
      fill="currentColor"
    />
  </svg>
);
